export default (val, size = 2, wholeName) => {
  if (!val) return 'UK'

  if (wholeName) {
    return val.split(' ').filter((_, idx) => idx <= size - 1).map($0 => $0.substring(0, size - 1).toUpperCase()).join('')
  }

  return val.substring(0, size - 1).toUpperCase()
}